"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactScrollToBottom = require("react-scroll-to-bottom");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _useFocusSendBox = _interopRequireDefault(require("../hooks/useFocusSendBox"));

var _useLocalize = _interopRequireDefault(require("../hooks/useLocalize"));

var _useScrollToEnd = _interopRequireDefault(require("../hooks/useScrollToEnd"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ScrollToEndButton = function ScrollToEndButton(_ref) {
  var className = _ref.className;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      scrollToEndButtonStyleSet = _useStyleSet2[0].scrollToEndButton;

  var focusSendBox = (0, _useFocusSendBox.default)();
  var scrollToEnd = (0, _useScrollToEnd.default)();
  var handleClick = (0, _react.useCallback)(function () {
    scrollToEnd();
    focusSendBox();
  }, [focusSendBox, scrollToEnd]);
  return _react.default.createElement("button", {
    className: (0, _classnames.default)(scrollToEndButtonStyleSet + '', className + ''),
    onClick: handleClick,
    type: "button"
  }, (0, _useLocalize.default)('New messages'));
};

ScrollToEndButton.defaultProps = {
  className: ''
};
ScrollToEndButton.propTypes = {
  className: _propTypes.default.string
};

var ConnectedScrollToEndButton = function ConnectedScrollToEndButton(props) {
  return _react.default.createElement(_reactScrollToBottom.StateContext.Consumer, null, function (_ref2) {
    var sticky = _ref2.sticky;
    return !sticky && _react.default.createElement(ScrollToEndButton, props);
  });
};

var _default = ConnectedScrollToEndButton;
exports.default = _default;